import { buildPostUrl } from '../buildPostUrl';
import { canDeleteAllImagesFromPosts } from '../canDeleteAllImagesFromPosts';
import { ISeoData } from '../../types/seo_data';
import { IPageInfoSchema } from '../../repositories/journal/entities/page_info/PageInfoSchema';
import { TPostState } from '../../types/post';
import { EStatus, EType } from '../../repositories/journal/entities/journal/JournalAttributesSchema';
import { IApplicationContext } from '../../types/applicationContext';

interface IGetSeoData {
  currentLayout: string;
  seoData?: ISeoData;
  pageMeta?: IPageInfoSchema;
  post?: TPostState;
  context?: IApplicationContext;
}

export const SeoDataDefault = {
  seo: {
    seoTitle: '',
    seoDescription: '',
    seoKeywords: '',
    seoImage: '',
    seoUrl: '',
    noIndex: false,
    noImageIndex: false,
  },
};
/**
 * Трансформирует метаданные в легаси сео-формат
 */
export const getSeoData = ({ currentLayout, pageMeta, post, seoData, context }: IGetSeoData): ISeoData => {
  if (currentLayout !== 'LayoutNew') {
    return seoData || SeoDataDefault;
  }

  if (pageMeta) {
    return {
      ...SeoDataDefault,
      seo: {
        ...SeoDataDefault.seo,
        seoTitle: pageMeta.metaTitle || SeoDataDefault.seo.seoTitle,
        seoDescription: pageMeta.metaDescription || SeoDataDefault.seo.seoDescription,
        seoKeywords: pageMeta.metaKeywords || SeoDataDefault.seo.seoKeywords,
        seoImage: pageMeta.metaImage || SeoDataDefault.seo.seoImage,
        seoUrl: pageMeta.canonicalUrl || SeoDataDefault.seo.seoUrl,
        noIndex: pageMeta.noIndex || SeoDataDefault.seo.noIndex,
        noImageIndex: false,
      },
    };
  }

  if (post && 'id' in post) {
    const {
      id,
      attributes: { type, slug, seoTitle, seoDescription, seoKeywords, image, noIndex, status, datePublish },
    } = post;

    return {
      ...SeoDataDefault,
      seo: {
        ...SeoDataDefault.seo,
        seoTitle: seoTitle || SeoDataDefault.seo.seoTitle,
        seoDescription: seoDescription || SeoDataDefault.seo.seoDescription,
        seoKeywords: seoKeywords || SeoDataDefault.seo.seoKeywords,
        seoImage: image || SeoDataDefault.seo.seoImage,
        seoUrl: `https://www.cian.ru${buildPostUrl({ type, slug, id }) || SeoDataDefault.seo.seoUrl}`,
        noIndex:
          noIndex ||
          // запрещаем индексацию для всех вопросов и постов блогов, которые еще не проверены
          ([EType.Blogs, EType.Questions].includes(type) && status !== EStatus.Checked) ||
          SeoDataDefault.seo.noIndex,
        noImageIndex: canDeleteAllImagesFromPosts(
          new Date(datePublish),
          context?.custom.deleteAllImagesFromPostsSettings,
        ),
      },
    };
  }

  return SeoDataDefault;
};
